import { action } from "./actionCreator";

export const PRESENCE_SET_STATUS = "presence/SET_STATUS";
export const VACATION_ASK_VACATION = "vacation/ASK_VACATION";
export const VACATION_REJECT_VACATION = "vacation/REJECT_VACATION";
export const VACATION_DELETE_VACATION = "vacation/DELETE_VACATION";
export const VACATION_MODIFY_VACATION = "vacaction/MODIFY_VACATION";
export const VACATION_VALIDATE_VACATION = "vacation/VALIDATE_VACATION";
export const GET_ABSENCE_TYPES = "GET_ABSENCE_TYPES";
export const SET_ABSENCE_TYPES = "SET_ABSENCE_TYPES";
export const PRESENCE_SET_VACATION_TYPES = "presence/SET_VACATION_TYPES";
export const PRESENCE_SET_BALANCE = "presence/SET_BALANCE";
export const PRESENCE_SET_SELECTEDUSER_VACATIONS = "presence/SET_VACATIONS";
export const PRESENCE_GET_VACATIONS_LIST = "presence/GET_VACATIONS_LIST";
export const PRESENCE_SET_LIST_VACATIONS = "presence/SET_LIST_VACATIONS";
export const PRESENCE_IS_LOADING = "PRESENCE_IS_LOADING";
export const ABSENCE_DECLARE_ABSENCE = "ABSENCE_DECLARE_ABSENCE";
export const PRESENCE_GET_PROGRESSIONS = "presence/GET_PROGRESSIONS";

/**
 * build action
 * @param type
 * @param payload
 * @return {{type: *}}
 */

export const presenceUpdate = (id, status) => action(PRESENCE_SET_STATUS, { id, status });

// vacations
export const askVacation = vacation => action(VACATION_ASK_VACATION, { payload: vacation });
export const modifyVacation = vacation => action(VACATION_MODIFY_VACATION, { payload: vacation });
export const rejectVacation = payload => action(VACATION_REJECT_VACATION, { payload });
export const deleteVacation = vacation => action(VACATION_DELETE_VACATION, { payload: vacation });
export const validateVacation = payload => action(VACATION_VALIDATE_VACATION, { payload });
export const getVacationsList = filters => action(PRESENCE_GET_VACATIONS_LIST, { payload: filters });

export const declareAbsence = absence => action(ABSENCE_DECLARE_ABSENCE, { payload: absence });



// WEBPACK FOOTER //
// src/modules/presence/actions/presence.js